// extracted by mini-css-extract-plugin
module.exports = {"fullPage":"LoadingSection_fullPage__33gjp"};